import * as React from 'react'
import {
  EmailField,
  HashFields,
  Label,
  PasswordField,
  TelephoneField,
  TextField,
} from 'react-rails-form-helpers'
import { ICrashdownGlobals } from '../../CrashdownTypeStubs'
import * as API from '../lib/api'

declare var crashdown: ICrashdownGlobals
declare var Routes: any

interface IProps {
  customer?: API.ICustomer
}

interface IState {
  emailAlreadyExists: boolean
  email: string
}

enum CustomerFormFieldsInState {
  Email = 'email',
}

export class CustomerForm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    const { customer } = props

    this.state = {
      email: (customer ? customer.email : null) || '',
      emailAlreadyExists: false,
    }
  }

  public handleChange = (field: CustomerFormFieldsInState, event: React.FormEvent<HTMLInputElement>) => {
    this.setState({ [field]: event.currentTarget.value })
  }

  public showLoginModal = (event: React.SyntheticEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    crashdown.setLoginModalEmail(this.state.email)
    crashdown.user_session.triggerLoginModal()
  }

  public checkEmailUniqueness = (e: React.FormEvent<HTMLFormElement>) => {
    const { currentTarget } = e
    const { value: email } = currentTarget

    if (currentTarget.checkValidity()) {
      fetch(
        Routes.igniter_account_uniqueness_check_path({ email }),
        { credentials: 'same-origin' },
      ).then((response) => {
        this.setState({
          emailAlreadyExists: response.ok,
        })
      })
    } else {
      this.setState({
        emailAlreadyExists: false,
      })
    }
  }

  public loginLink(instruction: string) {
    return <a href="#" onClick={this.showLoginModal}>{instruction}</a>
  }

  public emailBottomLabel() {
    const { emailAlreadyExists } = this.state

    if (emailAlreadyExists) {
      return (
        <Label
          className="field-bottom-label"
          htmlFor="email"
        >
          An account with this email address already exists. {this.loginLink('Please log in.')}
        </Label>
      )
    } else {
      return (
        <Label
          className="field-bottom-label"
          htmlFor="email"
        >
          Already have an account? {this.loginLink('Click here to log in.')}
        </Label>
      )
    }
  }

  public render() {
    const { customer } = this.props
    const {
      first_name: firstName,
      last_name: lastName,
      phone,
      company,
    } = customer || this.blankCustomer()
    const { email } = this.state

    return (
      <section className="customer-form">
        <h2>Create Your Account</h2>

        <HashFields name="customer">
          <Label htmlFor="email">Email</Label>
          <EmailField
            name="email"
            autoComplete="email"
            required={true}
            value={email}
            onChange={this.handleChange.bind(this, CustomerFormFieldsInState.Email)}
            onBlur={this.checkEmailUniqueness}
            style={{ marginBottom: 0 }}
          />
          {this.emailBottomLabel()}

          <Label htmlFor="password">Password</Label>
          <PasswordField name="password" autoComplete="new-password" required={true} />

          <div className="grid-x">
            <div className="cell small-full medium-30 medium-padded">
              <Label htmlFor="first_name">First Name</Label>
              <TextField
                name="first_name"
                autoComplete="given-name"
                required={true}
                defaultValue={firstName}
              />
            </div>

            <div className="cell small-full medium-30 medium-padded">
              <Label htmlFor="last_name">Last Name</Label>
              <TextField
                name="last_name"
                autoComplete="family-name"
                required={true}
                defaultValue={lastName}
              />
            </div>
          </div>

          <Label htmlFor="phone">Phone Number</Label>
          <TelephoneField name="phone" autoComplete="tel" required={true} defaultValue={phone}/>

          <Label htmlFor="company">Church/Organization</Label>
          <TextField name="company" autoComplete="organization" defaultValue={company}/>
        </HashFields>
      </section>
    )
  }

  private blankCustomer(): API.ICustomer {
    return {
      email: '',
      first_name: '',
      last_name: '',
      phone: '',
      company: '',
      church_size: '',
      tax_exempt: false,
      current_membership_is_trial: false,
    }
  }
}
